import React from 'react';
import { isArray, some } from 'underscore';
import { Container } from 'reactstrap';

// decorators
import ButtonDropdown from './button-dropdown';

const FieldButtonDropdown =
  Component =>
  ({ label, dropdownClassName, dropdownSize, ...props }) => {
    var isDirty = false;
    if (props.names) {
      isDirty = some(props.names, name => !!props[name].input.value);
    } else if (isArray(props.input.value)) {
      isDirty = props.input.value.length > 0;
    } else {
      isDirty = !!props.input.value;
    }

    const className = isDirty ? 'badge-dirty' : undefined;

    return (
      <ButtonDropdown
        label={label}
        groupClassName={className}
        className={dropdownClassName}
        size={dropdownSize}
      >
        <Container>
          <Component {...props} />
        </Container>
      </ButtonDropdown>
    );
  };

export default FieldButtonDropdown;



// WEBPACK FOOTER //
// ./src/decorators/field-button-dropdown.js